import { formatDate } from "@/lib/helpers/date";
import type { VisitDetailData } from "@/components/shared/visits/visit-detail";
import { app } from "@/config/env";

const formatTimeWithoutSeconds = (time: string | null | undefined) => {
  if (!time) return "";
  return time.slice(0, 5);
};

const getAppUrl = (): string => {
  if (typeof window !== "undefined" && window.location?.origin) {
    return window.location.origin;
  }
  return app.LUCE_WEB_DOMAIN;
};

export const buildDescriptionForSingleVisit = (
  description: string,
  visit: VisitDetailData,
): string => {
  const link =
    visit.modificationLink || `${getAppUrl()}/visits/reschedule?id=${visit.id}`;
  return `${description}\n\nNeed to reschedule? Tap here: ${link}`;
};

export const getVisitDateTime = (visit: VisitDetailData) => {
  const serviceDate = new Date(visit.serviceDate);
  const dateStr = formatDate(serviceDate);
  const startTime = visit.startTime
    ? formatTimeWithoutSeconds(visit.startTime)
    : "";
  const endTime = visit.endTime ? formatTimeWithoutSeconds(visit.endTime) : "";

  return {
    startDateTime: startTime
      ? `${dateStr}T${startTime}:00`
      : `${dateStr}T00:00:00`,
    endDateTime: endTime ? `${dateStr}T${endTime}:00` : `${dateStr}T23:59:59`,
    serviceDate: dateStr,
  };
};
